import React, { FunctionComponent, ReactElement } from 'react';
import { Origin } from '@upstart/harmony/lib/constants';
import { CgMailForward } from 'react-icons/cg';
import { Car } from '@upstart/harmony/lib/legos/carTypes';
import { Deal } from '@upstart/harmony/lib/legos/dealTypes';
import { User } from '@upstart/harmony/lib/legos/userTypes';
import {
  MdOutlineAssignment,
  MdOutlineDescription,
  MdOutlineSwapHorizontalCircle,
  MdOutlineAssignmentInd,
  MdPerson,
  MdSwapHoriz,
  MdOutlineArticle,
  MdOutlineSend,
} from 'react-icons/md';
import { isEmbeddedInCommandCenter } from 'util/commandCenter';
import './HeaderNotice.scss';
import { Pencil } from '@upstart/harmony/lib/legos/pencilTypes';

const icons = isEmbeddedInCommandCenter()
  ? {
      customer: MdPerson,
      tradeIns: MdSwapHoriz,
      viewForms: MdOutlineArticle,
      addNotes: MdOutlineArticle,
      printSend: MdOutlineSend,
    }
  : {
      customer: MdOutlineAssignmentInd,
      tradeIns: MdOutlineSwapHorizontalCircle,
      viewForms: MdOutlineAssignment,
      addNotes: MdOutlineDescription,
      printSend: CgMailForward,
    };

export interface HeaderNoticeProps {
  car?: Car;
  deal?: Deal | undefined;
  user?: User;
  onCustomerNameClick?: () => {};
  onSendClick?: () => {};
  viewForms?: boolean;
  showViewForms?: boolean;
  onViewFormsClick?: () => {};
  onAddNotesClick?: () => {};
  onTradeinsClick?: () => {};
  onOnlineHistoryClick?: () => void;
  hideUserDetails?: boolean;
  showNotesNotificationIcon?: boolean;
  pencil?: Pencil;
}

const HeaderNotice: FunctionComponent<HeaderNoticeProps> = props => {
  const {
    car,
    deal,
    user,
    onCustomerNameClick,
    onSendClick,
    viewForms,
    showViewForms,
    onViewFormsClick,
    onAddNotesClick,
    onTradeinsClick,
    hideUserDetails,
    showNotesNotificationIcon,
    pencil,
  } = props;
  const hasPencil = !!pencil;
  const applicant = (deal || {}).applicant || {};
  const salesperson = (user || {}).firstName
    ? `${user?.firstName} ${user?.lastName}`
    : '-';

  let nameLabel: any = '';
  if (applicant.firstName || applicant.lastName) {
    nameLabel = `${applicant.firstName || ''} ${applicant.lastName || ''}`;
  }

  // Check if deal was created in Chairman
  let nameComponent: ReactElement | null = null;
  const isApplicantEditable = (deal || {}).origin === Origin.DESKING;
  if (isApplicantEditable) {
    nameComponent = (
      <span className="pencil-header-name" onClick={onCustomerNameClick}>
        {nameLabel || 'ADD CUSTOMER DETAILS'}
      </span>
    );
  }

  return (
    <div className="pencil-header-notice">
      <div>
        {!hideUserDetails && (
          <div>
            <span className="heading">Salesperson:</span> {salesperson}
            <span className="heading">Customer:</span>{' '}
            {isApplicantEditable ? nameComponent : nameLabel}
          </div>
        )}

        {viewForms && (
          <>
            <span className="heading">Status:</span> {deal?.progress}
            <span className="heading">Type:</span> {deal?.origin}
            <span className="heading">Vehicle:</span> {car?.name}
          </>
        )}
      </div>
      <div className="heading-actions">
        {props.onOnlineHistoryClick &&
          deal?.origin === Origin.ONLINE &&
          deal?.crmNote && (
            <div
              className="pencil-header-send"
              onClick={props.onOnlineHistoryClick}
            >
              <MdOutlineDescription className="pencil-header-icon" />
              <div>Online History</div>
            </div>
          )}

        {hasPencil && (
          <div className="pencil-header-send" onClick={onTradeinsClick}>
            <icons.tradeIns
              data-testid="header-tradeInIcon"
              className="pencil-header-icon"
            />
            <div>Trade-Ins</div>
          </div>
        )}
        {showViewForms && (
          <div className="pencil-header-send" onClick={onViewFormsClick}>
            <icons.viewForms
              data-testid="header-viewFormsIcon"
              className="pencil-header-icon"
            />
            <div>View Forms</div>
          </div>
        )}
        {hasPencil && (
          <>
            <div className="pencil-header-send" onClick={onAddNotesClick}>
              {showNotesNotificationIcon && <div className="notification" />}
              <icons.addNotes
                data-testid="header-addNoteIcon"
                className="pencil-header-icon"
              />
              <div>Add Notes</div>
            </div>
            <div className="pencil-header-send" onClick={onSendClick}>
              <icons.printSend
                data-testid="header-sendIcon"
                className="pencil-header-icon"
              />
              <div>Print/Send</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderNotice;
